import { CircularProgress, Typography } from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import AppButton from "component/button/AppButton";
import PrimaryAuthLayout from "component/primaryAuthLayout/PrimaryAuthLayout";
import styles from "./VerificationCode.module.css";
import { useLocation } from "react-router-dom";
import AppBackdrop from "component/appBackdrop/AppBackdrop";
import AuthModalLayout from "component/authModalLayout/AuthModalLayout";

import { useNavigate } from "react-router";
import { useResendCode, useVerifyCode } from "api/mutations/auth";
import TTFSnackbar from "component/AppSnackbars/TTFSnackbar";
import { useForm } from "react-hook-form";
import ValidationMessage from "component/validationMessage/ValidationMessage";
import { yupResolver } from "@hookform/resolvers/yup";
import { verifiyCodeSchema } from "schemas/auth/AuthSchemas";
import Grid from "@mui/material/Unstable_Grid2";

function VerificationCode() {
  const { state } = useLocation();
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const {
    severity,
    message,
    openToast,
    setOpenToast,
    duration,
    verify,
    openModal,
    setOpenModal,
    loading: loadingVerification,
  } = useVerifyCode();
  const {
    resend,
    loading,
    severity2,
    message2,
    openToast2,
    setOpenToast2,
    duration2,
  } = useResendCode();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(verifiyCodeSchema),
  });

  const onSubmit = (data) => {
    if (state) {
      verify({
        otp: data.otp,
        email: state.email,
      });
    } else {
      navigate("/signup");
    }
  };

  const handleResendCode = () => {
    if (state) {
      resend({
        email: state.email,
      });
    } else {
      navigate("/signup");
    }
  };

  const handleGoToLogin = () => {
    navigate("/login", {
      state: {
        email: state.email,
      },
    });
  };

  return (
    <PrimaryAuthLayout>
      <div className={styles.verification_code}>
        <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
          <Grid container spacing={1.5}>
            <Grid xs={12} sm={8}>
              <div className={styles.heading}>
                <Typography variant="h6">Input Verification Code</Typography>
                <Typography>
                  A 5-Digit verification code was sent to the email provided,
                  input code to verify your account.
                </Typography>
              </div>
            </Grid>
            <Grid xs={12} sm={8}>
              <div className={styles.otp_inputs}>
                <input
                  type="number"
                  name="otp"
                  placeholder="Input OTP"
                  {...register("otp")}
                />
                <ValidationMessage message={errors?.otp?.message} />
              </div>
            </Grid>
            <Grid xs={12} sm={8}>
              <div className={styles.resend}>
                <Typography>
                  Didnt receive any code ?{" "}
                  <Link
                    to="/"
                    onClick={(e) => {
                      e.preventDefault();
                      handleResendCode();
                    }}
                  >
                    Resend
                  </Link>
                </Typography>
                {loading && (
                  <div className={styles.circular_progress}>
                    <CircularProgress />
                  </div>
                )}
              </div>
            </Grid>
            <Grid xs={12} sm={8}>
              <div className={styles.form_btn}>
                <AppButton
                  loading={loadingVerification}
                  
                  fullwidth
                  textColor="#FFFFFF"
                  btnBg="#0089FF"
                  btnText="Submit"
                />
              </div>
            </Grid>
          </Grid>
        </form>
      </div>
      <TTFSnackbar
        severity={severity || severity2}
        message={message || message2}
        open={openToast || openToast2}
        setOpen={setOpenToast || setOpenToast2}
        duration={duration || duration2}
      />
      <AppBackdrop
        openModal={openModal}
        handleCloseModal={() => {}}
        children={
          <AuthModalLayout
            handleClose={() => {
              setOpenModal(false);
              handleGoToLogin();
            }}
            icon={"success"}
            primaryText="Success"
            secondaryText="OTP Verification successful, close modal to head to Login page."
          />
        }
      />
    </PrimaryAuthLayout>
  );
}

export default VerificationCode;
